module.exports = __webpack_public_path__ + "static/media/mailbox-light.2c7b2018.svg";